<template>
  <main-content-layout title="이달의 대출실적" img-src="monthly_performance_icon.png">
    <template v-slot:content>
      <v-row class="monthly-loan-perform-content-layout" align="stretch" dense>
        <v-col class="monthly-loan-perform-content" cols="12">
          <span class="member-status-content-title">대출건수</span>
          <span>
            <strong class="amount-text">{{ monthlySumData.cnt }}</strong>건
          </span>
        </v-col>
        <v-col class="monthly-loan-perform-content" cols="12">
          <span class="member-status-content-title">대출금액</span>
          <span>
            <strong class="amount-text">{{ inputComma(monthlySumData.loanAmount) }}</strong>원
          </span>
        </v-col>
        <v-col class="monthly-loan-perform-content" cols="12">
          <span class="member-status-content-title">수수료(-VAT)</span>
          <span><strong class="amount-text">{{ inputComma(monthlySumData.feeTotal) }}</strong>원
          </span>
        </v-col>
      </v-row>
    </template>
  </main-content-layout>
</template>

<script>
import {mapGetters} from "vuex";
import MainContentLayout from "@/pages/Main/components/layout/MainContentLayout.vue";
import {axiosInstance} from "@/util/AxiosModule";
import DateMixin from "@/mixin/DateMixin";
import _ from "lodash";
import TableMixin from "@/mixin/TableMixin";

export default {
  name: "MonthlyLoanPerformance",
  components: {MainContentLayout},
  mixins: [DateMixin, TableMixin],
  data() {
    return {
      startDate: "",
      endDate: "",
      monthlySumData: {}
    }
  },
  computed: {
    ...mapGetters("login", {
      userData: "userData",
      isAdmin: "isAdmin",
      isManager: "isManager",
      isUser: "isUser"
    })
  },
  beforeMount() {
    const {fromDate, toDate} = this.getNowMonthAllDate();
    this.startDate = fromDate;
    this.endDate = toDate;
  },
  mounted() {
    if (this.isAdmin) {
      this.getMonthlyPerformanceTotal();
    }
    if (this.isManager) {
      this.getMonthlyPerformanceTeam();
    }
    if (this.isUser) {
      this.getMonthlyPerformance();
    }
  },
  methods: {
    async getMonthlyPerformanceTotal() {
      try {
        const { data } = await axiosInstance.get("/admin/performance/performance-all", {
          params: {
            stDt: this.startDate.replaceAll("-", ""),
            edDt: this.endDate.replaceAll("-", "")
          }
        });
        if (!_.isEmpty(data)) {
          this.monthlySumData = data.performanceAllSumByAmtList[0];
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    async getMonthlyPerformanceTeam() {
      try {
        const { data } = await axiosInstance.get("/private/performance/performance-team", {
          params: {
            stDt: this.startDate.replaceAll("-", ""),
            edDt: this.endDate.replaceAll("-", ""),
            team: this.userData.orgNm
          }
        });
        if (!_.isEmpty(data)) {
          this.monthlySumData = data.pormanceSum;
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    async getMonthlyPerformance() {
      try {
        const { data } = await axiosInstance.get("/private/performance/performance", {
          params: {
            stDt: this.startDate.replaceAll("-", ""),
            edDt: this.endDate.replaceAll("-", ""),
            team: this.userData.orgNm,
            nm: this.userData.memberNm
          }
        });
        if (!_.isEmpty(data)) {
          this.monthlySumData = data.performanceSum;
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.monthly-loan-perform-content-layout {
  width: 100%;
  .monthly-loan-perform-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin: 10px 0;
    padding: 0 16px;
    background-color: #ffffff;
    box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    font-size: min(4vw, 20px);
    .member-status-content-title {
      font-weight: bold;
    }
    .amount-text {
      margin-right: 2px;
    }
  }
}
</style>